import React from 'react';
import styled from 'styled-components';


const StyledRecenter = styled.button`
    width: 62px;
    height: auto;
    background-color: transparent;
    border: none;
    position: absolute;
    bottom: 120px;
    right: 2px;
    z-index: 1000;

    @media screen and (max-width: 767px) {
        bottom: 32%;
        right: 0;
    }

    @media screen and (orientation: landscape)  {
        bottom: 15vh;
    }

    &:focus {
        outline: #00BFA5;
    }
`


const RecenterControl = ({onClick}) => (
    <StyledRecenter onClick={onClick}>
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="40" height="40" rx="8" fill="white"/>
            <path
                d="M20 23.3002C21.8225 23.3002 23.3 21.8227 23.3 20.0002C23.3 18.1777 21.8225 16.7002 20 16.7002C18.1774 16.7002 16.7 18.1777 16.7 20.0002C16.7 21.8227 18.1774 23.3002 20 23.3002Z"
                fill="#546368"/>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M20 9C20.6075 9 21.1 9.49249 21.1 10.1V12.378C24.4723 12.8603 27.1397 15.5277 27.622 18.9H29.9C30.5075 18.9 31 19.3925 31 20C31 20.6075 30.5075 21.1 29.9 21.1H27.622C27.1397 24.4723 24.4723 27.1397 21.1 27.622V29.9C21.1 30.5075 20.6075 31 20 31C19.3925 31 18.9 30.5075 18.9 29.9V27.622C15.5277 27.1397 12.8603 24.4723 12.378 21.1H10.1C9.49249 21.1 9 20.6075 9 20C9 19.3925 9.49249 18.9 10.1 18.9H12.378C12.8603 15.5277 15.5277 12.8603 18.9 12.378V10.1C18.9 9.49249 19.3925 9 20 9ZM20 25.5C23.0376 25.5 25.5 23.0376 25.5 20C25.5 16.9624 23.0376 14.5 20 14.5C16.9624 14.5 14.5 16.9624 14.5 20C14.5 23.0376 16.9624 25.5 20 25.5Z"
                  fill="#546368"/>
        </svg>
    </StyledRecenter>
);


export default RecenterControl;